// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"Organizations_SearchInput__3h8Je"};